import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[ds365StepIndicator]',
  standalone: false
})
export class StepIndicatorDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}